import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getTenantListWithoutPaginate } from '@/services/tenantService';
import { QUERY_KEYS } from '@/shared/constant/queryKeys';
import { CACHE_TIMES } from '@/shared/config/reactQuery';
import {
  getSelectedTenant,
  setSelectedTenant,
} from '@/shared/utils/tenantStorage';

const useTenantList = (name) => {
  const {
    data: tenantList,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: QUERY_KEYS.TENANT_ALL(name),
    queryFn: () => getTenantListWithoutPaginate(name),

    select: (response) => {
      const tenants = response.data || [];
      return tenants.map((tenant) => ({
        value: tenant.id,
        label: tenant.name,
        description: tenant.description,
        created_at: tenant.created_at,
        updated_at: tenant.updated_at,
      }));
    },
    staleTime: CACHE_TIMES.LONG,
    gcTime: CACHE_TIMES.VERY_LONG,
    refetchOnWindowFocus: false,
  });

  // Auto-select first tenant if none selected
  useEffect(() => {
    if (!isLoading && tenantList && tenantList.length > 0) {
      const currentTenant = getSelectedTenant();

      // If no tenant selected OR selected tenant doesn't exist in list
      const tenantExists =
        currentTenant &&
        tenantList.some((t) => String(t.value) === String(currentTenant));

      if (!currentTenant || !tenantExists) {
        const firstTenantId = String(tenantList[0].value);
        setSelectedTenant(firstTenantId);
        // Force trigger event to update all components
        window.dispatchEvent(new CustomEvent('tenantChanged'));
      }
    }
  }, [tenantList, isLoading]);

  return {
    tenantList: tenantList || [],
    isLoading,
    error,
    refetch,
  };
};

export default useTenantList;
